export default "__VITE_ASSET__b3a92d60__"